import { Skeleton } from '@components/base';
import { Card, CardHeader } from '@mui/material';
import css from './index.module.scss';

const OrderProgressSkeleton = () => {
  return (
    <div className={css.Skeletonwrapper}>
      <OrderProgressSkeletonCard />
      <OrderProgressSkeletonCard />
      <OrderProgressSkeletonCard />
      <OrderProgressSkeletonCard />
      <OrderProgressSkeletonCard />
    </div>
  );
};

const OrderProgressSkeletonCard = () => {
  return (
    <Card>
      <CardHeader
        sx={{ display: 'flex', flexDirection: 'row-reverse', justifyContent: 'space-between' }}
        avatar={<Skeleton animation="wave" variant="circular" width={40} height={40} />}
        title={<Skeleton animation="wave" height={20} width="60%" style={{ marginBottom: 6 }} />}
        subheader={<Skeleton animation="wave" height={20} width="30%" />}
      />
    </Card>
  );
};

export default OrderProgressSkeleton;
